export default __webpack_public_path__ + "static/media/misc-pantry1.3fa6d994.jpg";